<template lang="pug">
  div
    //- チェックインガイドモーダル
    CheckinGuide
    .container-fluid
      .wrapper
        #news.mt-3.pl-2
          .badge.mr-2 new
          router-link(to="/rockyInfo/258") 小川山ボルダー[水晶スラブ周辺]
          router-link.ml-3(to="/rockyInfo/260") 小川山ボルダー[林の中]
          |など他9エリア。小川山の画像トポ刷新！！
          router-link(to="/blog/20221114") 詳細はブログにて
        //-岩場参照履歴
        .spinner
          b-spinner.mt-5.mb-5(variant="primary" label="Loading..." v-if="isRecentRockyListLoading")
        div.text-center.my-5(v-if="falseInfo") 情報の取得に失敗しました
        #latest-record(v-if="isLogin & latestRecordList.length > 0 && !falseInfo")
          .header-title(v-if="!isRecentRockyListLoading") 最近見た岩場 
            //-最近見た岩場の削除
            i.far.fa-trash-alt(@click="restRecentRockyList()")
          carousel(v-bind:per-page-custom=[[100,3],[768,4]] :autoplay="false" :navigation-enabled="false" :pagination-enabled="false" navigation-prev-label="〈" navigation-next-label="〉" :speed="1000")
            slide(v-for="rocky in this.latestRecordList")
              .thumbnail-wrapper(@click="callRockyRecord(rocky.rockyId)")
                img.slide-img(:src="getRockyImgThumbPath(rocky.imgPath)" :alt="rocky.rockyName")
                .thumbnail-info
                  .rocky-nameKana {{ rocky.nameKana }}
                  .rocky-name {{rocky.rockyName}}
        //-ランディング(未ログイン時)
        #landing.mt-3(v-if="!isLogin")
          carousel(v-bind:per-page-custom=[[100,1],[768,1]] :autoplay="true" :loop="true" :autoplayTimeout="5000" :navigation-enabled="false" :pagination-enabled="false" navigation-prev-label="〈" navigation-next-label="〉" :speed="1000")
            slide(v-for="item in this.landingImgList")
              .thumbnail-wrapper-landing
                div.thumbnail-info-wrapper(v-if="item.no == 0")
                  img.slide-img(:src="item.imgPath" alt="")
                  .thumbnail-info-free-cover
                  .thumbnail-info-free
                    div.free-title 
                      a 約200岩場の岩場情報が見放題！
                    div.pt-1.pt-md-3.pb-md-2.free-explanation
                      div.mb-md-2
                        span#month-cost.position-relative 月額300円(税込) 
                        span#triangle.ml-2.mr-2
                          i.fas.fa-caret-right
                        span#free 初月無料
                      div.explanation お支払方法のご登録から１ヶ月間無料！
                      div.explanation （いつでも無料会員に変更可能です。）
                      div
                        img#climer-img1(:src="makeImgPath('/img/top/slide_0_irasuto1.png')" alt="")
                        img#climer-img2(:src="makeImgPath('/img/top/slide_0_irasuto2.png')" alt="")
                    div.mt-2.mt-md-5
                      b-button(pill variant='primary' @click="callRouterInfo('/register_user/send_auth')") 
                        span <small>（１ヶ月間無料）</small>
                        |<b>会員登録する</b>
                div(v-else)
                  img.slide-img(:src="item.imgPath" alt="")
                  .thumbnail-info
                    .info-main(v-html="item.infoMain")
                    .info-sub {{item.infoSub}}
                    .link-create-user
                      button.info-btn(@click="callRouterInfo('/register_user/send_auth')") 
                        | 新規ユーザー登録
                    .link-site-info
                      button.info-btn(@click="callRouterInfo('info/user_guide')")
                        | ヤマラボの楽しみ方

      .wrapper#map-wrapper
        #top-page-map.position-relative
          Map(:isCustumExpandCtlShow="true")

      .wrapper
        //-登攀記録
        .spinner
          b-spinner.mt-5.mb-5(variant="primary" label="Loading..." v-if="isClimbCountLoading")
        #climbing-count(v-if="isLogin && !isClimbCountLoading")
          div.text-center.my-5(v-if="falseInfo") 情報の取得に失敗しました
          #climbing-count-wrapper(@click="callRouterPush()" v-if="!falseInfo")
            .div
              .headline 登攀記録
              .detail
                .inner
                  .title 総ルート
                  .count-ranking
                    .count {{climbingCount.climbAllRoute}}
                    .ranking {{ranking.climbAllRouteRank > 0 && climbingCount.climbAllRoute > 0 ? ranking.climbAllRouteRank : ' - ' }}位
                .inner
                  .title 完登ルート
                  .count-ranking
                    .count {{climbingCount.climbCompleteRoute}}
                    .ranking {{ranking.climbCompleteRouteRank  > 0 && climbingCount.climbCompleteRoute > 0  ? ranking.climbCompleteRouteRank : ' - ' }}位
            .div
              .headline チェックイン記録
              .detail 
                .inner
                  .title 都道府県
                  .count-ranking
                    .count {{checkinCount.prefectures}}
                    .ranking {{ranking.checkinPrefecturesRank  > 0 && checkinCount.prefectures > 0  ? ranking.checkinPrefecturesRank : ' - ' }}位
                .inner
                  .title 岩場
                  .count-ranking
                    .count {{checkinCount.rocky}}
                    .ranking {{ranking.checkinRockyRank  > 0 && checkinCount.rocky > 0  ? ranking.checkinRockyRank : ' - ' }}位
                .inner
                  .title 岩
                  .count-ranking
                    .count {{checkinCount.rock}}
                    .ranking {{ranking.checkinRockRank  > 0 && checkinCount.rock > 0  ? ranking.checkinRockRank : ' - ' }}位
        //-アプリバナー
        .d-flex.mt-4.mb-4
          .row.no-gutters.w-100
            .col-12
              #app-bunner.row.no-gutters
                img(src="img/app_banner.png")
                #icon-box.d-flex
                  #android-icon
                    a(href="https://play.google.com/store/apps/details?id=jp.yamalab.app" target="_blank") 
                      img(src="img/googleplay_badge.png")
                  #ios-icon
                    a(href="https://apps.apple.com/jp/app/%E3%83%A4%E3%83%9E%E3%83%A9%E3%83%9C/id6449830234?itsct=apps_box_link&itscg=30200" target="_blank") 
                      img(src="img/apple_badge.png")
        //-3Dバナー
        #rock3dModelBunner.mt-3.mb-3(@click="callRouterInfo('/3d_model')") 
          //-PC用
          .row.no-gutters.w-100#vrBunnerPC
            .col-4
              .subtitle トポを3Dでみる新体験
            .col-3
              .imgBox
                img(:src="get3DImgPath('3dModel3.png')")
            .col-5
              .header 新企画
              .title 外岩3Dモデル
          //-モバイル用
          .row.no-gutters.w-100#vrBunnerMobile
            .col-5
              .imgBox
                img.ml-3(:src="get3DImgPath('3dModel3.png')")
            .col-7
                .header.ml-3 新企画
                .title.ml-3 外岩3Dモデル
                .subtitle.ml-3 トポを3Dでみる新体験
        //-バナー(未ログイン時)
        #notloginBunner.d-flex.mt-4.mb-4(v-if="!isLogin")
          .row.no-gutters.w-100
            .col-12.col-md-6.w-100
              .bunner-box-left
                #mitake-bunner.b-block(@click="callRockyInfo(demoRockyId)")
            .col-12.col-md-6.w-100
              .bunner-box-right
                #search-bunner.b-block(@click="callSearchView()")
                  p.p-sub1 次はどの岩に登る？
                  p.p-main 
                    i.fa.fa-search 岩場を探す
                  p.p-sub2 検索はここから
        //-ヤマラボブログ
        #yamalab-blog.b-block
          .row.no-gutters
            .col-6.col-md-7.text-white.banner-title.pl-1.pl-md-3
              .banner-text1 管理人ブログ
              .banner-text2.mt-1 トポの追加や、岩場の最新情報をお届け
            .col-6.col-md-5.banner-box.p-2
              .post(v-for="item in blogData")
                a(:href="getBlogLink(item.date.replace(/-/g, ''))" target="_blank" rel="noopener")
                  .date.text-white {{item.date.replace(/-/g, '/')}}
                  //-ヘッドラインまたはタイトルを表示する
                  .heading.text-white {{getHeadLine(item)}}
                  .thumbnail-box
                    .thumbnail-innner(v-for="img in getBlogThumbnail(item)")
                      img(:src="img")
              .text-right.banner-text3
                a.text-white(href="/blog" target="_blank" rel="noopener") more &gt;
              
        //-お勧めエリア
        #recommend
          .header-title おすすめ岩場
          carousel(v-bind:per-page-custom=[[100,3],[768,4]] :autoplay="false" :navigation-enabled="false" :pagination-enabled="false" navigation-prev-label="〈" navigation-next-label="〉" :speed="1000")
            slide(v-for="rocky in this.recommendList")
              .thumbnail-wrapper(@click="callRockyInfo(rocky.rockyId)")
                  img.slide-img(:src="getRockyImgThumbPath(rocky.imgPath)" :alt="rocky.rockyName")
                  .thumbnail-info
                    .rocky-nameKana {{ rocky.nameKana }}
                    .rocky-name {{rocky.rockyName}}
        //- 投稿募集・twitter 
        div.d-flex.flex-wrap.mt-2.mb-5.rocky-pj-container
          .col-12.col-md-6.rocky-pj
            .title.mt-1 みんなの岩場プロジェクト
            .explanation.mt-2 岩場情報　募集中！
            .taking-applications.mt-3 <b>ヤマラボではユーザーの皆様と一緒に外岩クライミングを盛り上げていきたいと考えております。ぜひ岩場の現地情報をお寄せください。</b>
            div.pl-2.pr-2.mt-4
              div.d-flex.justify-content-between.mb-3
                .header アクセス・駐車場
                .header 現地情報
            div.pl-2.pr-2.mb-3
              div.d-flex.justify-content-between
                .header おすすめスポット
                .header 登攀のご感想
            .taking-applications.text-center お送りいただいた情報は確認後、順次掲載いたします。
            .taking-applications.text-center ヤマラボにあったらいいなという機能・ご要望も募集中です!
            button.btn.btn-info.mt-3(type='button' @click="callRouterInfo('/feed_back/input')") 投稿はこちらから
          .col-12.col-md-6.text-center.twitter-box
            //- twitterのnodeモジュール
            a.twitter-timeline(href='https://twitter.com/YamaLab1' data-width='380' data-height='360') 
        //- p 使用可能なストレージの約{{this.storage}} % を使用しています

</template>

<script>
import Map from '@/components/Map.vue'
import CheckinGuide from '@/components/guide/checkin_guide'

import { Carousel, Slide } from 'vue-carousel'

// PWAの更新機能
// import update from '../mixins/update'
// キャッシュストレージ取得(デバッグ用)
// import getStorage from '../mixins/getStorage'

import axios from 'axios'

export default {
  //mixins: [update],
  // データオブジェクト
  props: {
  },
  data() {
    return {
      isLogin: this.$user.isLogin,
      pageAllData: null,
      isFriendRequestModalShow:false,
      latestRecordList: [],
      recommendList: [
        {'rockyId': 14, 'rockyName' : '御岳ボルダー', 'imgPath' : this.makeImgPath('/img/rp/0014_001.jpg'), 'nameKana' : 'みたけぼるだー'},
        {'rockyId': 204, 'rockyName' : '笠置山[大岩ごけエリア]', 'imgPath' : this.makeImgPath('/img/rp/0204_001.jpg'), 'nameKana' : 'かさぎやま'},
        {'rockyId': 79, 'rockyName' : '豊田[大田エリア]', 'imgPath' :this.makeImgPath('/img/rp/0079_001.jpg'), 'nameKana' : 'とよた'},
        {'rockyId': 214, 'rockyName' : '王子ヶ岳[ニコニコ岩周辺]', 'imgPath' : this.makeImgPath('/img/rp/0214_001.jpg'), 'nameKana' : 'おうじがたけ'}
      ],
      climbingCount: null,
      checkinCount: null,
      ranking: null,
      landingImgList: [
        {'no': 0,'infoMain':'','infoSub':'','imgPath':this.makeImgPath('/img/top/slide_0.jpg')},
        {'no': 1,'infoMain':'<span style="color:#FFC400; font-size:1.7rem;">外岩</span>に登りに行こう！','infoSub':'クライミング記録を集めよう！','imgPath':this.makeImgPath('/img/top/slide_1.jpg')},
        {'no': 2,'infoMain':'国内の<span style="color:#fd8602; font-size:1.7rem;">岩場</span>を検索できる</p>','infoSub':'','imgPath':this.makeImgPath('/img/top/slide_2.jpg')},
        {'no': 3,'infoMain':'岩場近くの<br/><span style="color:#b5fdb3;" font-size:1.7rem;>コンビニ・温泉情報</span>を掲載','infoSub':'','imgPath':this.makeImgPath('/img/top/slide_3.jpg')},
        {'no': 4,'infoMain':'<span style="color:#14c6d3; font-size:1.7rem;">トポ（ルート）</span>を<br/>確認できる','infoSub':'','imgPath':this.makeImgPath('/img/top/slide_4.jpg')},
        {'no': 5,'infoMain':'外岩クライミングを<br/><span style="color:#8dcafc; font-size:1.7rem;">記録</span>できる','infoSub':'','imgPath':this.makeImgPath('/img/top/slide_5.jpg')},
      ],
      //Loading表示用(isLogin=trueの場合true)
      isRecentRockyListLoading:this.$user.isLogin,
      isClimbCountLoading:this.$user.isLogin,
      allRockyJsonData:[],
      isExpanded:false,
      falseInfo: false,
      blogData:[],
      demoRockyId:process.env.VUE_APP_DEMO_ROCKY_ID,
    }
  },
  mounted() {
    //twitter対応
    setTimeout(() => {
      let tweetScript = document.createElement('script')
      tweetScript.setAttribute('src', 'https://platform.twitter.com/widgets.js')
      tweetScript.setAttribute('async', 'true')
      document.head.appendChild(tweetScript)
    }, 100)
  },
  created() {
    this.createdProcess()

    this.getBlog()
    // 提携先識別IDがクエリに存在する場合は保存
    if(this.$route.query.sid !== undefined){
      localStorage.sid = this.$route.query.sid
    }
  },
  destroyed(){
    // MAPを最大表示している状態でヘッダーナビボタンから遷移する場合の対策
    // PCでのスクロール禁止解除
    document.removeEventListener("mousewheel", this.scroll_control, { passive: false });
    // スマホでのタッチ操作でのスクロール禁止解除
    document.removeEventListener('touchmove', this.scroll_control, { passive: false });
  },
  // メソッド
  methods: {
    // ブログ記事データ取得
    getBlog() {
      axios.get(process.env.VUE_APP_API_GATEWAY + '/api-blog', {
        params: {
          "type": "banner",
          "limit": 7
        },
        headers: {
          'Authorization': this.$user.idToken
        }
      })
      .then(res => {
        this.blogData = res.data
      })
      .catch(err => {
        console.log(err)
      })
    },

    getBlogLink(path) {
      return "/blog/" + path
    },
    getHeadLine(item){
      if(item.headline == undefined){
        return item.title
      }else{
        return item.headline
      }
    },
    getBlogThumbnail(param){
      let retuenList = new Array()
      //サムネイルの1枚目はブログデータのサムネイルとする
      retuenList.push(this.makeImgPath(param.imagePath))

      //ブログの記事本文からimgタグを抽出する
      const parser = new DOMParser();
      const htmlDoc = parser.parseFromString(param.article, 'text/html');
      const imgList = htmlDoc.querySelectorAll('img')

      imgList.forEach( data => {
        //サムネイルと同じ画像は含めない
        if(!data.src.includes(param.imagePath)){
          retuenList.push(data.src)
        }
      })
      //先頭3要素を返す
      return  retuenList.slice(0, 3)
    },
    async createdProcess(){
      //ログイン時のみ取得
      if(this.isLogin){
        //登攀件数取得
        await this.getUserClimbingCheckinCount()
        //ランキング取得
        await this.getUserRanking()
        //Loading解除
        this.isClimbCountLoading = false
        //全岩場JSON
        await this.getAllRockyJson()
        //ユーザー情報(最近見た岩場)
        this.getUserInfo()
      }
    },
    //-------------------------------------------
    //トップページ上でチェックインされた場合の処理
    //-------------------------------------------
    reloadMyPage(){
      //チェックイン件数をリロードする
      this.getUserClimbingCheckinCount()
    },
    //------------------------
    //全岩場JSON取得
    //------------------------
    async getAllRockyJson(){
      //岩場情報JSON
      let jsonUrl = process.env.VUE_APP_MATERIAL_URL + '/allRockyList.json'
      await axios
        .get(jsonUrl)
        .then(response => {
          this.allRockyJsonData = response.data
        })
        .catch(err => {
          this.falseInfo = true
          this.isRecentRockyListLoading = false
          this.isClimbCountLoading = false
        })

      //データが0件の場合
      if(this.allRockyJsonData.length == 0){
        //ここでデータが取得できない場合は、データ不正
        await this.asyncDialog('システムエラー：岩場情報を取得できませんでした')
        return
      }
    },

    //------------------------
    //ユーザー情報取得
    //------------------------
    async getUserInfo() {
      const jsonUrl = process.env.VUE_APP_API_GATEWAY + '/api-user-info'
      await axios
        .get(jsonUrl,{
          params: {},
          headers: {
            'Authorization': this.$user.idToken
          }
        })
        .then(response => {
          //最近見た岩場
          const responseData = response.data[0]
          let wkRockyIdList = responseData.recentRockyIdList
          wkRockyIdList.forEach((rockyId) => {

            //allRockyList.jsonから岩場名を取得する
            let rockyJsonData = this.allRockyJsonData.filter(record => record.rockyId == rockyId)
            // 非公開になったものが含まれる場合エラーになるため
            if(rockyJsonData[0] == null) return;
            let wkObj = {
              rockyId : rockyId,
              imgPath : rockyJsonData[0].imgPath,
              rockyName : rockyJsonData[0].name,
              nameKana : rockyJsonData[0].nameKana
            }

            this.latestRecordList.push(wkObj)
          })

          //描画フラグ
          this.isRecentRockyListLoading = false

        })
        .catch(err => {
          console.log(err)
          this.falseInfo = true
          this.isRecentRockyListLoading = false
          this.isClimbCountLoading = false
        })
    },
    //------------------------
    //登攀件数取得
    //------------------------ 
    async getUserClimbingCheckinCount(){
      let jsonUrl = process.env.VUE_APP_API_GATEWAY + '/api-user-info/user-climbing-checkin-count'

      await axios
        .get(jsonUrl,{
          params: {
            'userId': this.$user.userId
          },
          headers: {
            'Authorization': this.$user.isLogin ? this.$user.idToken : 'no-login'
          }
        })
        .then(response => {
          let result = response.data
          //登攀件数
          this.climbingCount = result.climbingCount
          //チェックイン件数
          this.checkinCount = result.checkinCount

        })
        .catch(err => {
          this.falseInfo = true
          this.isRecentRockyListLoading = false
          this.isClimbCountLoading = false
        })
    },
    //------------------------
    //ランキング取得
    //------------------------ 
    async getUserRanking(){
      let jsonUrl = process.env.VUE_APP_API_GATEWAY + '/api-user-info/user-ranking'

      await axios
        .get(jsonUrl,{
          params: {
            'userId': this.$user.userId
          },
          headers: {
            'Authorization': this.$user.isLogin ? this.$user.idToken : 'no-login'
          }
        })
        .then(response => {
          let result = response.data
          //ランキング
          this.ranking = result.ranking
        })
        .catch(err => {
          this.falseInfo = true
          this.isRecentRockyListLoading = false
          this.isClimbCountLoading = false
        })
    },
    //------------------------
    //最近見た岩場のリセット
    //------------------------
    async restRecentRockyList(){
      
      const message = '最近見た岩場をクリアしますか？'
      const answer1 = 'クリアする'
      const answer2 = 'キャンセル'
      if(!await this.asyncDialogAnswer(message,answer1,answer2)){
        return
      }

      //API実行
      const url = process.env.VUE_APP_API_GATEWAY + '/api-user-info'
      const params = {
        rockyId : this.rockyId,
        resetFlg : 'true'
      }
      //更新実行
      try {
        await axios.patch(url, params, {
          headers: {
            'Authorization': this.$user.idToken
          }
        })
      } catch(err) {
        alert('岩場参照履歴をクリアできませんでした。')
        return
      }

      //App.vueのunReadNoticeを更新する。
      this.latestRecordList = []

    },
    asyncDialogAnswer(message,answer1,answer2) {
      return new Promise((resolve) => {
        this.$bvModal.msgBoxConfirm(message, {
          title: '確認',
          okVariant: 'success',
          okTitle: answer1,
          cancelTitle: answer2,
          footerClass: 'p-2',
          hideHeaderClose: false,
          centered: true
        })
        .then(value => {
          resolve(value)
        })
      })
    },
    callRouterPush(){
      this.$router.push('/myPage/' + this.$user.userId +'/userInfoTop')
    },
    callRouterInfo(path){
      this.$router.push(path)
    },
    callSearchView(){
      this.$router.push('/rocky/search')
    },
    callRockyInfo(rockyId){
      //TOP画面のMAPの中央位置とzoomの保持を解除する
      localStorage.isLastMapCentervalid = false
      this.$router.push('/rockyInfo/' + rockyId)
    },
    callRockyRecord(rockyId){
      //サンプル画像以外の場合遷移する
      if(rockyId!=''){
        //TOP画面のMAPの中央位置とzoomの保持を解除する
        localStorage.isLastMapCentervalid = false
        this.$router.push('/rockyInfo/' + rockyId)
      }
    },
    makeImgPath(imgPath){
      return process.env.VUE_APP_MATERIAL_URL + imgPath
    },
    getRockyImgThumbPath(imgPath){
      return this.getRockyThumbPath(imgPath,'360')
    },
    asyncDialog(msg) {
      return new Promise((resolve) => {
        this.$bvModal.msgBoxOk(msg, {
          size: 'sm',
          buttonSize: 'sm',
          okVariant: 'success',
          headerClass: 'p-2 border-bottom-0',
          footerClass: 'p-2 border-top-0',
          centered: true
        })
        .then(value => {
          resolve(value)
        })
        .catch(err => {
          // An error occurred
        })
      })
    },
    //mapを拡大する
    mapFull(){
      this.isExpanded = true

      let wrapperEl = document.getElementById('map-wrapper')
      wrapperEl.style.width = '100%'
      wrapperEl.style.overflow = 'hidden'
      wrapperEl.style.paddingLeft = '0'
      wrapperEl.style.paddingRight = '0'
      wrapperEl.style.overflow = 'hidden'

      let mapEl = document.getElementById('top-page-map')
      var y = mapEl.getBoundingClientRect().top

      const ua = navigator.userAgent
      if(ua.indexOf('Trident') !== -1) {
        //IE 11の場合はナビがstickyにならないので、上いっぱいまで表示する。
        window.scrollBy(0,y)
      }else{
        window.scrollBy(0,y-62)
      }

      mapEl.style.zIndex = '1'
      mapEl.style.width = '100vw'

      let buttonEl = document.getElementById('expand-button')

      if(window.innerWidth< 414){
        mapEl.style.height = 'calc(100vh - 65px)'
      }else{
        buttonEl.style.right = '2rem'
        mapEl.style.height = '100vh'        
      }

      // PCでのスクロール禁止
      document.addEventListener("mousewheel", this.scroll_control, { passive: false });
      // スマホでのタッチ操作でのスクロール禁止
      document.addEventListener("touchmove", this.scroll_control, { passive: false });
    },
    //mapを元に戻す
    mapFullReset(){
      this.isExpanded = false

      let wrapperEl = document.getElementById('map-wrapper')
      wrapperEl.style.width = ''
      wrapperEl.style.overflow = ''
      wrapperEl.style.paddingLeft = ''
      wrapperEl.style.paddingRight = ''
      wrapperEl.style.overflow = ''

      let mapEl = document.getElementById('top-page-map')
      mapEl.style.height = ''
      mapEl.style.zIndex = ''
      mapEl.style.width = ''

      let buttonEl = document.getElementById('expand-button')
      buttonEl.style.right = '0.5rem'

      // PCでのスクロール禁止解除
      document.removeEventListener("mousewheel", this.scroll_control, { passive: false });
      // スマホでのタッチ操作でのスクロール禁止解除
      document.removeEventListener('touchmove', this.scroll_control, { passive: false });
    },
    scroll_control(event) {
      event.preventDefault();
    },
    get3DImgPath(img){
      return process.env.VUE_APP_MATERIAL_URL + "/img/3dModelLanding/" + img
    },
  },
  // コンポーネント
  components: {
    Carousel,
    Slide,
    Map,
    CheckinGuide
  }
}
</script>

<style lang="stylus" scoped>

#app
.container-fluid
  padding-left 0px
  padding-right 0px
.wrapper
  padding-left 0px
  padding-right 0px
.header-title
  font-size 1.3rem
  line-height 1.3rem
  margin 0.5rem 0
  position relative
  i
    position absolute
    right 1rem
    top 0.3rem
    font-size 1rem
    color #adb4b9
    cursor pointer

//コンテナ群
#friend-request
  display flex
  //右寄せ
  justify-content flex-end
  padding-top 2rem
  color #eceeef
  text-align right
  padding-right 0.5rem
  font-size 0.8rem
  color #5aa7de
  #friend-link
    cursor pointer
    i  
      font-weight 600
      text-decoration underline

#news
  border 1.5px solid #a6d2ff
  border-radius 5px
  .badge
    border-radius 10px
    background #17a2b8
    color #fff
    font-size 0.8rem
    font-weight 500
  a
    color #007bff
    text-decoration underline
    cursor pointer

#latest-record
  padding 10px 0 20px 0

//スライダー（ランディング以外）
.VueCarousel-slide
  align-items center
  justify-content center
  border-right 3px solid #FFF
  box-sizing border-box
.thumbnail-wrapper
  position relative
.thumbnail-wrapper:hover
  opacity 0.7
  transition-duration 0.3s
.slide-img,.thumbnail-info
  width 100%
  cursor pointer
.slide-img
  height 100px
  object-fit cover
.thumbnail-info
  height 45%
  position absolute
  bottom 0
  background-color rgba(0, 0, 0, 0.5)
  .climbing-date
    padding-left 0.5rem
    font-size 0.7rem
    color #d2d3d4
  .rocky-name
    color white
    padding-left 0.5rem
    font-size 0.8rem
    overflow hidden
    text-overflow ellipsis
    white-space nowrap
  .rocky-nameKana
    color white
    padding-left 0.5rem
    font-size 0.4rem
    overflow hidden
    text-overflow ellipsis
    white-space nowrap
  .recommend-rocky-name
    padding-left 0.5rem
    font-size 0.8rem
    color white
    overflow hidden
    text-overflow ellipsis
    white-space nowrap

//スライダー（ランディング）(スマホ表示)
#landing
  .thumbnail-wrapper-landing
    position relative
    .slide-img,.thumbnail-info
      width 100%
      height 200px
      cursor default
    .slide-img
      object-fit cover
    .thumbnail-info-free-cover
      position absolute
      width 100%
      height 170px
      top 15px
      left 0
      background rgba(0,0,0,0.5);
    .thumbnail-info-free
      position absolute
      width 100%
      top 30px
      left 0
      text-align center
      .free-title
        a
          background #000
          padding 5px 25px
          font-size 1rem
          font-weight 500
          color #00B0F0
      .free-explanation
        color #fff
        position relative
        #month-cost
          text-decoration-line line-through
          text-decoration-style double
          font-size 1rem
        #triangle,#free
          color #FFFF00
          font-size 1.7rem
          font-weight 600
        .explanation
          font-size 0.8rem
          small
            font-weight 500
        #climer-img1,#climer-img2
          position absolute
          width 10%
        #climer-img1
          top 60px
          left 7vw
        #climer-img2
          top 77px
          right 13vw
      .btn
        height 30px
        font-size 0.9rem
        span
          color #FFFF00
          font-size 0.7rem
    .thumbnail-info
      position absolute
      background-color rgba(0, 0, 0, 0.4)
      text-align center
      .info-main,.info-sub,.link-create-user,.link-site-info
        width 100%
        position absolute
        color #FFF
      .info-main,.info-sub
        font-weight 700
      .info-main
        top 55px
        font-size 1.3rem
        letter-spacing 2.6px
      .info-sub
        top 90px
      .link-create-user,.link-site-info
        text-decoration-line underline
        text-align right
        font-size 0.8rem
        padding-right 0.8rem    
        a 
          color white
      .link-create-user
        top 20px
        display none      
      .link-site-info
        top 160px

.info-btn
  border solid 1px #fff
  border-radius 3px
  background rgba(0,0,0,0.2)
  color #FFF
  cursor pointer
.info-btn:hover
  background rgba(0,0,0,0.8)

.spinner
  text-align center

//登攀件数
#climbing-count-wrapper
  margin-bottom 1rem
  cursor pointer
  .headline
    font-size 0.8rem
    background #004170
    color #FFF
    padding-left 0.5rem
  .detail
    display flex
    .inner
      border 0.5px #cfd3d7 solid
      width 50%
      padding 0 0.5rem
      .title
        font-size 0.6rem
        font-weight 500
      .count-ranking
        display flex
        align-items center
        justify-content center  
        .count
          color #006fbe
          font-weight 700        
        .ranking
          margin-left 0.7rem
          background #dee1e3
          color #606e79
          font-size 0.6rem  
          padding 0 1rem
          border-radius 10%
#recommend
  padding-bottom 15px

//地図
#top-page-map
  width 100%
  height 280px

.bunner-box-left
  display flex
  justify-content: flex-start

.bunner-box-right
  margin-top 1.5rem
  display flex
  justify-content flex-end

#app-bunner
  justify-content center
  align-items center
  img
    position relative
    width 100%
  #icon-box
      position absolute
      max-height 70px
      left 39.5%
      top 52%
    #android-icon
      width 50%
      img
        width 100%
        height 100%
    #ios-icon
      width 50%
      display flex
      align-items center
      img
        width 85%
        height 65%

  #android-icon,#ios-icon
    img
      cursor pointer 
    &:hover
      filter brightness(120%)

#mitake-bunner
  background-image url(/img/mitake_bunner.png)
#search-bunner
  background-image url(/img/search_bunner.png)
  position relative
  p
    color #314A78
    text-align center
  .p-main
    font-size 1.2rem
    font-weight 500
    position absolute
    left 0
    right 0
    margin auto
    top 45px
  .p-sub1,.p-sub2
    font-size 0.2rem
    position absolute
    left 0
    right 0
    margin auto
  .p-sub1
    top 30px
  .p-sub2
    top 73px

#rock3dModelBunner
  display block
  height 100px
  background #030821
  color #fff
  cursor pointer
  #vrBunnerMobile
    display flex
    .imgBox
        width 100%
        height 100px
        display flex
        justify-content center
        align-items center
      img
        max-height 80px
    .title,.subtitle
      font-family '游明朝','Yu Mincho',YuMincho,'Hiragino Mincho Pro',serif;
    .header
      margin-top 18px
      letter-spacing .2rem
      font-size 0.5rem
    .title
      font-size 1.7rem
    .subtitle
      font-size 0.5rem
      letter-spacing .25rem
  #vrBunnerPC
    display none

#mitake-bunner,#search-bunner
  background-repeat no-repeat
  background-size cover
  background-position center
  width 100%
  height 120px
  &:hover
    filter brightness(110%)
    cursor pointer
    transition 0.3s

//ヤマラボブログ
#yamalab-blog
  background-image: url(/img/yamalab_blog.jpeg);
  background-repeat: no-repeat
  background-size: cover
  height 130px
.banner-box
  z-index 2
  background rgba(0, 0, 0, 0.3)
  display inline-block
  height 120px
  overflow-y scroll
  white-space nowrap
  &::-webkit-scrollbar
    width 7px
    height 7px
  &::-webkit-scrollbar-track
    border-radius 5px
    box-shadow 0 0 4px #01274a inset
  &::-webkit-scrollbar-thumb
    border-radius 5px
    background #eceeef
  &::-webkit-scrollbar-track
    border-radius 5px
    box-shadow 0 0 4px #01274a inset

//投稿単位のcard
.post
  margin-bottom 10px
  border-radius 2px
  background rgba(0, 0, 0, 0.8)
  &:hover
    background rgba(1, 39, 74, 0.8)
    cursor pointer
    transition 0.3s
  a
    color #333
    text-decoration none
    .date
      padding 5px 0 0 5px
      font-size 0.5rem
    .heading
      padding-left 5px
      font-size 0.5rem
      white-space pre-wrap //改行コードを有効にする
      text-overflow ellipsis
      overflow hidden

    .thumbnail-box
      padding-left 5px
      padding-bottom 10px
      display flex
      flex-wrap wrap
      width 100%
      .thumbnail-innner
        img
          width 80px
          height auto
          margin 10px 10px 0 0
  
.banner-text2
  font-size .5rem
.banner-text3
  font-size 10px
  white-space nowrap
  overflow hidden
  text-overflow ellipsis
.banner-title
  padding-top 35px

.rocky-pj-container
  .twitter-box,.rocky-pj
    height 380px
  .twitter-box
    padding 10px 0
    background #f0f2e7
  .rocky-pj
    text-align center
    padding 1rem
    background-image url(/img/rocky_pj.jpg)
    background-color rgba(255,255,255,0.7)
    background-blend-mode lighten;
    background-repeat no-repeat
    background-size cover
    background-position center
    .title
      font-size 1.2rem
      font-weight 600
    .explanation
      font-size 0.7rem
      padding 5px 0
      font-size 0.9rem
      font-weight 600
      background #c5b503
      background #000
      color #fff
    .taking-applications
      text-align left
      font-size 0.7rem
      font-weight 500
    .header
      height 30px
      width 45%
      display flex
      justify-content center
      align-items center
      font-size 0.8rem
      background-color rgba(0,0,0,0.5)
      color #fff
      border-radius 10px

// 中デバイス（タブレット, 768px 以上）
@media (min-width: 768px)
  .thumbnail-info
    height 32%
    .climbing-date
      padding-left 1rem
      font-size 1rem
    .rocky-name
      padding-left 1rem
      font-size 1.2rem
    .rocky-nameKana
      padding-left 1rem
      font-size .7rem
    .recommend-rocky-name
      padding-left 1rem
      padding-top 0.5rem
      color white
  .slide-img
    height 220px
  #top-page-map
    height 400px
  //ランディング(768px 以上)
  #landing
    .thumbnail-wrapper-landing
      .slide-img,.thumbnail-info
        height 350px
      .thumbnail-info-free-cover
        height 240px
        top 35px
        left 0
      .thumbnail-info-free
        top 80px
        left 0
        .free-title
          a
            font-size 1.7rem
        .free-explanation
          #month-cost
            font-size 1.6rem
          #triangle,#free
            font-size 2rem
          .explanation
            font-size 0.9rem
          #climer-img1,#climer-img2
            width 8%
          #climer-img1
            top 30px
            left calc(15% + 10px)
          #climer-img2
            top 80px
            right calc(20% + 10px)
        .btn
          height 35px
          font-size 1rem
          span
            font-size 0.8rem
      .thumbnail-info
        .link-create-user
          display block
        .info-main
          font-size 1.5rem
          top 125px
        .info-sub
          font-size 1.2rem
          top 160px
        .link-create-user
          top 20px
        .link-site-info
          top 300px
  .bunner-box-right
    margin-top 0rem          
  #mitake-bunner,#search-bunner
    width 99.5%
    height 180px
    
  #search-bunner
    .p-main
      font-size 1.7rem
      font-weight 600
      letter-spacing 0.1rem
      top 67px
    .p-sub1,.p-sub2
      font-size 0.5rem
      letter-spacing 0.12rem
    .p-sub1
      top 51px
    .p-sub2
      top 113px

  #app-bunner
    background #137C8A
    justify-content center
    align-items center
    img
      position relative
      width 55%
      height 55%
    #icon-box
        position absolute
        max-height 70px
        left 44.5%
        top 55%
        width 22%

  #rock3dModelBunner
    height 150px
    #vrBunnerPC
      height 150px
      display flex
      .title,.subtitle
        font-family '游明朝','Yu Mincho',YuMincho,'Hiragino Mincho Pro',serif;
      .subtitle
        font-size 1.3rem
        height 100%
        display flex
        justify-content center
        align-items center
      .imgBox
        width 100%
        height 150px
        display flex
        justify-content center
        align-items center
        img
          max-height 120px
      .header
        margin-top 2rem
        margin-left 1.7rem
        font-size 0.8rem
        letter-spacing .3rem
      .title
        font-size 3rem
        margin-left 1.7rem
    #vrBunnerMobile
      display none

  //ヤマラボブログ
  #yamalab-blog
    height 177px
  .banner-box
    height 177px
  .banner-title
    padding-top 60px
  .banner-text1
    font-size 1.4rem
  .banner-text2
    font-size .7rem
  .banner-text3
    font-size .8rem
  .post
    margin 5px
    margin-bottom 10px
    border-radius 2px
    padding 5px
    a
      .date
        font-size 0.5rem
      .heading
        font-size 0.8rem
      .thumbnail-box
        .thumbnail-innner
          img
            width 100px
            height auto
            margin 10px 10px 0 0

// 大デバイス（デスクトップ, 1170px 以上）
@media (min-width 1170px)
  #app
    .wrapper
      background #FFF
  #friend-request
    color #006fbe

  #rock3dModelBunner
    #vrBunnerPC
      display flex
      .subtitle
        font-size 1.5rem
      .title
        font-size 3rem
    #vrBunnerMobile
      display none

  //ヤマラボブログ
  #yamalab-blog
    height 220px
  .banner-box
    height 220px
  .banner-title
    padding-top 70px
  .banner-text1
    font-size 1.8rem
  .banner-text2
    font-size 1rem
  .banner-text3
    font-size 1.1rem
  .rocky-pj-container
    .rocky-pj
      .title
        font-size 1.4rem
        font-weight 600
      .explanation
        font-size 1rem
        font-weight 600
      .taking-applications
        font-size 0.9rem
        font-weight 400
      .header
        font-size 0.8rem
      .detail
        font-size 0.7rem
//IE11且つPC表示の場合
@media screen and (-ms-high-contrast: active) and (min-width: 1120px), screen and (-ms-high-contrast: none)  and (min-width: 1120px)
  #landing
    .thumbnail-wrapper
      .slide-img,.thumbnail-info
        height 450px
      .thumbnail-info
        .info-main
          font-size 1.5rem
          top 175px
        .info-sub
          font-size 1.2rem
          top 160px
        .link-create-user
          top 40px
          right 30px
        .link-site-info
          top 380px
          right 30px

</style>